import { jsx as a, jsxs as m } from "react/jsx-runtime";
import { useMediaQuery as g, useTab as f, useMultiStyleConfig as x, Box as n, Button as T, VisuallyHidden as R, Flex as S, AspectRatio as _, Image as v } from "@chakra-ui/react";
import W from "react";
import { ThemeRadiusVariable as d, ThemeSpaceVariable as w } from "../../theme/theme-types.js";
const H = W.forwardRef((c, u) => {
  const [t] = g("(min-width: 48em)"), e = t ? "96px" : "72px", { imgAlt: b, imgSrc: h, imgFallbackColor: r, children: o, isDisabled: i } = c, s = f({
    ...{ isDisabled: i },
    ref: u
  }), l = x("Tabs", {
    variant: "default",
    size: t ? "md" : "sm"
  }), p = r ? /* @__PURE__ */ a(
    n,
    {
      bg: r,
      w: e,
      minW: e,
      h: e,
      minH: e,
      borderRadius: d.Medium
    }
  ) : void 0;
  return /* @__PURE__ */ m(T, { variant: "unsyled", isDisabled: i, __css: l.tabWithImage, ...s, children: [
    /* @__PURE__ */ a(R, { children: o }),
    /* @__PURE__ */ m(S, { direction: "column", align: "center", role: "group", children: [
      /* @__PURE__ */ a(_, { ratio: 1, maxWidth: e, minWidth: e, mb: w.XSmall, children: /* @__PURE__ */ a(
        v,
        {
          src: h,
          alt: b,
          h: e,
          w: e,
          userSelect: "none",
          borderRadius: d.Medium,
          fallback: p
        }
      ) }),
      /* @__PURE__ */ a(
        n,
        {
          outline: "none",
          __css: l.tab,
          "data-selected": s["aria-selected"] ? !0 : void 0,
          "data-disabled": i ? !0 : void 0,
          children: o
        }
      )
    ] })
  ] });
});
export {
  H as CustomTabWithImage
};
